export default {
  "account": {
    "curatedCollections": "Kuraterede samlinger",
    "curatedCollectionsInfo": "Find nedenfor alle samlinger, du har kurateret",
    "editProfile": "Rediger profil",
    "likes": "Synes om'er",
    "linkAccount": "Min konto",
    "linkLogin": "Log ind",
    "linkLoginJoin": "Login/Deltag",
    "linkLogout": "Log ud",
    "myProfile": "Min profil",
    "notifications": {
      "loggedIn": "Du er nu logget ind. Velkommen!",
      "loggedOut": "Du er nu logget ud.",
      "noCollections": {
        "curated": "Du har ikke kurateret nogen samlinger endnu",
        "private": "Du har ikke oprettet nogen private gallerier endnu",
        "public": "Du har ikke oprettet nogen offentlige gallerier endnu"
      },
      "noLikedItems": "Du har ikke syntes om nogen artikler endnu"
    },
    "privateCollections": "Private gallerier",
    "profile": "Mine synes om'er og gallerier",
    "profileSettings": "Profilindstillinger",
    "publicCollections": "Offentlige gallerier",
    "settings": "Indstillinger",
    "title": "Min konto"
  },
  "actions": {
    "accept": "Acceptere",
    "cancel": "Annuller",
    "close": "luk",
    "continue": "fortsæt",
    "download": "Hent",
    "edit": "Rediger",
    "feedback": "Feedback",
    "goBack": "Tilbage",
    "goHome": "Gå til hjemmesiden",
    "learnMore": "Lær mere",
    "like": "Synes om",
    "move": "Bevæge sig",
    "next": "Næste",
    "pin": "Pin",
    "preview": "Forhåndsvisning",
    "previous": "Forrige",
    "providedBy": "Leveret af {provider}",
    "reject": "Afvise",
    "save": "Gem",
    "send": "Sende",
    "share": "Del",
    "shareOn": "Del på {social}",
    "skip": "Springe",
    "viewAt": "Se på {link}",
    "viewDocument": "Se dokument"
  },
  "attribution": {
    "country": "Land:",
    "creator": "Oprettet af:",
    "date": "Dato:",
    "institution": "Institution:",
    "title": "Titel:"
  },
  "automatedCardGroup": {
    "item": "Seneste varer",
    "organisation": "Organisationer",
    "place": "Steder",
    "time": "Udvalgte århundreder",
    "topic": "Udvalgte emner"
  },
  "blog": {
    "author": "Forfatter",
    "authors": "Forfattere",
    "blog": "Blog",
    "by": "af",
    "categories": "Kategorier",
    "category": "Kategori",
    "posts": "Blogindlæg",
    "published": "Offentliggjort {date}",
    "relatedPosts": "Relaterede indlæg"
  },
  "cardLabels": {
    "organisation": "Organisation",
    "person": "Person",
    "place": "Sted",
    "theme": "Tema",
    "time": "Århundrede",
    "topic": "Emne"
  },
  "clearAllFilters": "ryd alle filtre",
  "collections": {
    "actions": {
      "edit": "Rediger samling",
      "update": "Opdater samling"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "designere",
          "name": "Designer | Designere",
          "select": "Vælg designere"
        },
        "proxy_dc_format": {
          "moreName": "teknikker",
          "name": "Teknik | Teknikker",
          "select": "Vælg teknikker"
        },
        "proxy_dc_type": {
          "moreName": "varetyper",
          "name": "Artikeltype | Artikeltyper",
          "select": "Vælg varetyper"
        },
        "proxy_dcterms_medium": {
          "moreName": "materialer",
          "name": "Materiale | Materialer",
          "select": "Vælg materialer"
        }
      }
    },
    "form": {
      "description": "Beskrivelse"
    },
    "notifications": {
      "update": "Samlingen er blevet opdateret"
    }
  },
  "collectionsYouMightLike": "Samlinger, du måske vil synes om",
  "colourSwatch": "Farveprøve",
  "contentYouMightLike": "Indhold, du måske vil synes om",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Flere oplysninger",
      "about": "Om Europeana",
      "forDevelopers": "For udviklere",
      "help": "Hjælp",
      "meetUs": "Mød holdet",
      "provide": "Bliv dataleverandør",
      "subscribe": "Abonner på vores nyhedsbrev",
      "terms": "Vilkår for brug og Fortrolighedspolitik"
    },
    "headerNavigation": {
      "Collections": "Samlinger",
      "explore": "Udforsk",
      "teachers": "Lærere"
    }
  },
  "curatedAutomatically": "Kurateret automatisk af Europeana",
  "dateFilter": {
    "endDate": "Slutdato",
    "specificDate": "Specifik dato",
    "startDate": "Startdato",
    "to": "til"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API nøgle",
      "noRequests": "Der blev ikke brugt nogen anmodninger til Europeana API'er på denne side.",
      "settingsPageLinkText": "indstillinger side",
      "tip": "Tip: Hvis du allerede har en {apiKeyLink}, kan du indtaste den på {settingsPageLink} og den vil blive inkluderet i disse API-anmodningslinks.",
      "title": "API-anmodninger"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Indtast din Europeana API-nøgle, og den vil blive brugt i links til API-anmodninger.",
          "label": "API nøgle"
        },
        "enabled": {
          "description": "Hvis den er aktiveret, vil fejlretningsmenuen blive vist i sidefoden.",
          "label": "Aktiver fejlretningsmenu"
        }
      },
      "title": "Indstillinger"
    }
  },
  "delete": "Slet",
  "depiction": "En skildring af {title}",
  "directions": {
    "left": "Venstre",
    "right": "Højre"
  },
  "edmIsShownAtLinkAlt": "Vis på udbyderens websted",
  "entity": {
    "actions": {
      "cancel": "Annuller",
      "pin": "Fastgør vare",
      "unpin": "Frigør vare",
      "viewPinned": "Se fastgjorte emner"
    },
    "labels": {
      "entity": "Enhed"
    },
    "notifications": {
      "deleted": "Dit galleri er blevet slettet.",
      "error": {
        "unpin": "Der opstod en fejl under frigørelse af elementet. Prøv venligst igen, eller rapporter problemet."
      },
      "pin": "Dette element vises øverst i samlingen \" {entity} \". Vi giver dig besked, når denne ændring vil være synlig på indsamlingssiden.",
      "pinLimit": {
        "body": "Indtil videre kan du kun fastgøre 24 elementer på den første side. Hvis du vil fastgøre dette emne, skal du fjerne et andet emne og derefter prøve at fastgøre dette emne igen.",
        "title": "For mange fastgjorte emner"
      },
      "pinned": "Elementet er blevet fastgjort. Det er nu øverst på den første side i denne samling. Det kan tage op til 24 timer at vises for alle.",
      "select": "Vælg en relateret enhed for at fastgøre/frigøre elementet til/fra det.",
      "unpin": "Dette element stopper med at blive vist øverst i samlingen \" {entity} \". Vi giver dig besked, når denne ændring vil være synlig på indsamlingssiden.",
      "unpinned": "Elementet er blevet fastgjort. Det er ikke længere øverst på den første side i denne samling. Det kan tage op til 24 timer at forsvinde for alle."
    }
  },
  "error": "Fejl",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Dette er ikke muligt, fordi private gallerier kun er synlige for deres skaber. Hvis du kender skaberen af galleriet, så bed dem om at gøre galleriet offentligt. Alternativt kan du rapportere dette problem ved hjælp af feedback-knappen.",
      "metaTitle": "Galleri uautoriseret",
      "title": "Ups! {newline} Du forsøger at se en anden persons private galleri."
    },
    "itemNotFound": {
      "description": "Dette kan skyldes følgende årsager: denne vare findes ikke, eller; den blev offentliggjort, fordi den ikke opfyldte vores kvalitetskriterier, eller; den blev opdateret og genudgivet med en ny unik identifikator, i hvilket tilfælde prøv at finde varen igen.",
      "metaTitle": "Varen blev ikke fundet",
      "title": "Åh nej! {newline} Vi kunne ikke finde denne vare."
    }
  },
  "exhibitions": {
    "chapters": "Kapitler",
    "credits": "Credits",
    "currentChapter": "Aktuelt kapitel",
    "description": "Udforsk udstillingerne",
    "exhibitions": "Udstillinger"
  },
  "explore": "Udforske",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "farver",
      "name": "Farve | Farver",
      "options": {
        "#000000": "Sort",
        "#000080": "Marine blå",
        "#00008B": "Mørkeblå",
        "#0000CD": "Medium blå",
        "#0000FF": "Blå",
        "#006400": "Mørkegrøn",
        "#008000": "Webgrøn",
        "#008080": "Teal",
        "#008B8B": "Mørk Cyan",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Mørkt turkis",
        "#00FA9A": "Medium Spring Green",
        "#00FF00": "Grøn",
        "#00FF7F": "Spring Green",
        "#00FFFF": "Cyan",
        "#191970": "Midnight Blue",
        "#1E90FF": "Dodgers blå",
        "#20B2AA": "Lys havgrøn",
        "#228B22": "Forest Green",
        "#2E8B57": "Havgrøn",
        "#2F4F4F": "Mørke skifergrå",
        "#32CD32": "Lime grøn",
        "#3CB371": "Medium Sea Green",
        "#40E0D0": "turkis",
        "#4169E1": "Kongeblå",
        "#4682B4": "Stålblå",
        "#483D8B": "Mørke skifer blå",
        "#48D1CC": "Medium turkis",
        "#4B0082": "indigo",
        "#556B2F": "Mørk olivengrøn",
        "#5F9EA0": "Kadetblå",
        "#6495ED": "kornblomst",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Medium akvamarin",
        "#696969": "Mørk grå",
        "#6A5ACD": "Skifer blå",
        "#6B8E23": "Olivengrøn",
        "#708090": "Skifergrå",
        "#778899": "Lys skifergrå",
        "#7B68EE": "Medium skiferblå",
        "#7CFC00": "Græsplæne grøn",
        "#7F0000": "Web maroon",
        "#7F007F": "Lilla på nettet",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "akvamarin",
        "#800000": "Rødbrun",
        "#800080": "Lilla",
        "#808000": "Oliven",
        "#808080": "Grå web",
        "#87CEEB": "Himmelblå",
        "#87CEFA": "Lys himmelblå",
        "#8A2BE2": "Blå violet",
        "#8B0000": "Mørkerød",
        "#8B008B": "Mørk magenta",
        "#8B4513": "Sadelbrun",
        "#8FBC8F": "Dark Sea Green",
        "#90EE90": "Lysegrøn",
        "#9370DB": "Medium lilla",
        "#9400D3": "Mørk violet",
        "#98FB98": "Lysegrøn",
        "#9932CC": "Mørk orkidé",
        "#9ACD32": "Gul grøn",
        "#A020F0": "Lilla",
        "#A0522D": "Sienna",
        "#A52A2A": "Brun",
        "#A9A9A9": "Mørkegrå",
        "#ADD8E6": "Lyseblå",
        "#ADFF2F": "Grøn Gul",
        "#AFEEEE": "Bleg turkis",
        "#B03060": "Rødbrun",
        "#B0C4DE": "Lys stålblå",
        "#B0E0E6": "Pulverblå",
        "#B22222": "firebrick",
        "#B8860B": "Mørk gyldenris",
        "#BA55D3": "Medium Orkidé",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Mørk kaki",
        "#BEBEBE": "Grå",
        "#C0C0C0": "Sølv",
        "#C71585": "Medium violet-rød",
        "#CD5C5C": "Indisk rød",
        "#CD853F": "Peru",
        "#D2691E": "Chokolade",
        "#D2B48C": "Tan",
        "#D3D3D3": "Lysegrå",
        "#D8BFD8": "Thistle",
        "#DA70D6": "Orchid",
        "#DAA520": "Gyldenris",
        "#DB7093": "Blegviolet rød",
        "#DC143C": "Crimson",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Blomme",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Let Cyan",
        "#E6E6FA": "Lavendel",
        "#E9967A": "Mørk laks",
        "#EE82EE": "Violet",
        "#EEE8AA": "Bleg Goldenrod",
        "#F08080": "Lys koral",
        "#F0E68C": "khaki",
        "#F0F8FF": "Alice blå",
        "#F0FFF0": "Honeydew",
        "#F0FFFF": "Azure",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Hvede",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Hvid røg",
        "#F5FFFA": "Mint fløde",
        "#F8F8FF": "Spøgelse hvid",
        "#FA8072": "Laks",
        "#FAEBD7": "Antik hvid",
        "#FAF0E6": "Linned",
        "#FAFAD2": "Let Goldenrod",
        "#FDF5E6": "Gammel blonde",
        "#FF0000": "Rød",
        "#FF00FF": "Fuchsia",
        "#FF1493": "Dyb pink",
        "#FF4500": "Orange rød",
        "#FF6347": "Tomat",
        "#FF69B4": "Hot pink",
        "#FF7F50": "Koral",
        "#FF8C00": "Mørk orange",
        "#FFA07A": "Lys laks",
        "#FFA500": "orange",
        "#FFB6C1": "Lyserød",
        "#FFC0CB": "Lyserød",
        "#FFD700": "Guld",
        "#FFDAB9": "Fersken pust",
        "#FFDEAD": "Navajo White",
        "#FFE4B5": "Mokkasin",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Blanched Mandel",
        "#FFEFD5": "Papaya pisk",
        "#FFF0F5": "Lavendel rødme",
        "#FFF5EE": "Seashell",
        "#FFF8DC": "CORNSiLK",
        "#FFFACD": "Lemon Chiffon",
        "#FFFAF0": "Blomsterhvid",
        "#FFFAFA": "Sne",
        "#FFFF00": "Gul",
        "#FFFFE0": "Lysegul",
        "#FFFFF0": "Elfenben",
        "#FFFFFF": "hvid"
      },
      "select": "Vælg farver"
    },
    "COUNTRY": {
      "name": "Leverende land",
      "options": {
        "Albania": "Albanien",
        "Austria": "Østrig",
        "Belarus": "Hviderusland",
        "Belgium": "Belgien",
        "Bosnia and Herzegovina": "Bosnien-Hercegovina",
        "Bulgaria": "Bulgarien",
        "Croatia": "Kroatien",
        "Cyprus": "Cypern",
        "Czech Republic": "Tjekkiet",
        "Denmark": "Danmark",
        "Estonia": "Estland",
        "Europe": "Europa",
        "Finland": "Finland",
        "France": "Frankrig",
        "Georgia": "Georgien",
        "Germany": "Tyskland",
        "Greece": "Grækenland",
        "Holy See (Vatican City State)": "Hellig Stol (Vatikanstaten)",
        "Hungary": "Ungarn",
        "Iceland": "Island",
        "Ireland": "Irland",
        "Israel": "Israel",
        "Italy": "Italien",
        "Latvia": "Letland",
        "Lithuania": "Litauen",
        "Luxembourg": "Luxembourg",
        "Macedonia": "Makedonien",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Montenegro",
        "Netherlands": "Nederlandene",
        "Norway": "Norge",
        "Poland": "Polen",
        "Portugal": "Portugal",
        "Romania": "Rumænien",
        "Russia": "Rusland",
        "Serbia": "Serbien",
        "Slovakia": "Slovakiet",
        "Slovenia": "Slovenien",
        "Spain": "Spanien",
        "Sweden": "Sverige",
        "Switzerland": "Schweiz",
        "Turkey": "Tyrkiet",
        "Ukraine": "Ukraine",
        "United Kingdom": "Det Forenede Kongerige",
        "United States of America": "Amerikas Forenede Stater"
      },
      "select": "Vælg leverer lande"
    },
    "CREATOR": {
      "moreName": "skabere",
      "name": "Skaber | Skaberne",
      "select": "Vælg skabere"
    },
    "DATA_PROVIDER": {
      "moreName": "institutioner",
      "name": "Institution",
      "select": "Vælg institutioner"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Billedretning | Billedretninger",
      "options": {
        "landscape": "Landskab",
        "portrait": "Portræt"
      },
      "select": "Vælg billedorienteringer"
    },
    "IMAGE_SIZE": {
      "name": "Billedstørrelse | Billedstørrelser",
      "options": {
        "extra_large": "Ekstra stor 4MP + (f.eks. 2688 x 1520px)",
        "large": "Stor 1-4MP (f.eks 1920x1080px)",
        "medium": "Medium 0,5-1MP (f.eks. 850x850px)",
        "small": "Lille < 0,5MP (f.eks. 650x600px)"
      },
      "select": "Vælg billedstørrelser"
    },
    "LANGUAGE": {
      "name": "Sprog",
      "options": {
        "ar": "Arabisk",
        "bg": "Bulgarsk",
        "bs": "Bosnisk",
        "ca": "Catalansk",
        "cs": "Tjekkisk",
        "cy": "Walisisk",
        "da": "Dansk",
        "de": "Tysk",
        "el": "Græsk",
        "en": "Engelsk",
        "es": "Spansk",
        "et": "Estisk",
        "fi": "Finsk",
        "fr": "Fransk",
        "ga": "Irsk",
        "gd": "Gælisk",
        "he": "Hebraisk",
        "hr": "Kroatisk",
        "hu": "Ungarsk",
        "is": "Islandsk",
        "it": "Italiensk",
        "lt": "Litauisk",
        "lv": "Lettisk",
        "mk": "Makedonsk",
        "mt": "Maltesisk",
        "mul": "Flere sprog",
        "nl": "Hollandsk",
        "no": "Norsk",
        "pl": "Polsk",
        "pt": "Portugisisk",
        "ro": "Rumænsk",
        "ru": "Russisk",
        "sk": "Slovakisk",
        "sl": "Slovensk",
        "sq": "Albansk",
        "sr": "Serbisk",
        "sv": "Svensk",
        "tr": "Tyrkisk",
        "uk": "Ukrainsk"
      },
      "select": "Vælg sprog"
    },
    "MIME_TYPE": {
      "name": "Filformat | Filformater",
      "options": {
        "text/plain": "Almindelig tekst"
      },
      "select": "Vælg filformater"
    },
    "PROVIDER": {
      "moreName": "aggregatorer",
      "name": "Aggregator",
      "select": "Vælg aggregatorer"
    },
    "REUSABILITY": {
      "name": "Må jeg videreformidle dette?",
      "options": {
        "open": "Ja",
        "permission": "Måske, søg tilladelse",
        "restricted": "Ja, med betingelser",
        "uncategorized": "Ikke kategoriseret"
      },
      "select": "Vælg, om du kan bruge dette"
    },
    "TYPE": {
      "name": "Medietype",
      "options": {
        "3D": "3D",
        "IMAGE": "Billede",
        "SOUND": "Lyd",
        "TEXT": "Tekst",
        "VIDEO": "Video"
      },
      "select": "Vælg typer af medier"
    },
    "api": {
      "name": "Søg efter",
      "options": {
        "fulltext": "Poster med fuldtekst",
        "metadata": "Kun metadata-poster"
      },
      "switch": "Søg kun i indholdet af elementer med fuldtekst",
      "switchMoreInfo": "I denne samling kan du vælge, hvad du vil søge efter: Hvis denne knap er slået til, vil du søge i avis- og dokumentteksten; hvis den er slået fra, vil du i stedet søge i de oplysninger, der beskriver emnet, ligesom du altid gør i de fleste andre samlinger."
    },
    "button": {
      "apply": "Anvend",
      "cancel": "Annuller",
      "morefilters": "Flere filtre",
      "reset": "Nulstil",
      "showAll": "Vis alle {label}",
      "showLess": "Vis mindre {label}"
    },
    "collection": {
      "name": "Tema",
      "options": {
        "archaeology": "Arkæologi",
        "art": "Kunst",
        "fashion": "Mode",
        "industrial": "Industriel kulturarv",
        "manuscript": "Manuskripter",
        "map": "Kort og geografi",
        "migration": "Migration",
        "music": "Musik",
        "nature": "Naturhistorie",
        "newspaper": "Aviser",
        "photography": "Fotografi",
        "sport": "Sport",
        "ww1": "Første Verdenskrig"
      },
      "select": "Vælg et tema"
    },
    "contentTier": {
      "name": "Varekvalitet",
      "options": {
        "*": "Indeholder artikler, der ikke opfylder vores udgivelseskriterier",
        "0": "Vis kun artikler, der ikke opfylder vores udgivelseskriterier",
        "1": "Lav kvalitet",
        "2": "Mellem kvalitet",
        "3": "Høj kvalitet og genanvendelig med betingelser",
        "4": "Høj kvalitet og frit genanvendelig"
      },
      "select": "Vælg varekvaliteter"
    },
    "moreOptions": "Søg for at finde {0} mere {1}.",
    "proxy_dc_format": {
      "name": "Format | Formater",
      "select": "Vælg formater"
    },
    "proxy_dc_type": {
      "name": "Type | typer",
      "select": "Vælg typer"
    },
    "proxy_dcterms_issued": {
      "name": "Udstedelsesdato"
    },
    "proxy_dcterms_medium": {
      "name": "Medie | Medier",
      "select": "Vælg medie"
    }
  },
  "feedback": {
    "emailOptional": "Vi ønsker måske at følge op. Indtast din e-mail, hvis du er glad for, at vi kontakter dig.",
    "failed": "Anmodningen mislykkedes. Prøv igen.",
    "form": {
      "placeholders": {
        "email": "Indtast din e-mailadresse",
        "feedback": "Indtast din feedback her"
      }
    },
    "policies": "Ved at fortsætte accepterer du vores {0} og anerkender vores {1} .",
    "privacyPolicy": "Fortrolighedspolitik",
    "success": "Din feedback er sendt.",
    "termsOfService": "Vilkår for brug",
    "thankYou": "Tak!",
    "title": "Send feedback",
    "validEmail": "Indtast en gyldig email addresse",
    "validFeedback": "Din feedback skal mindst bestå af 5 ord"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Bidragydere",
      "dcCoverage": "Sted-tid",
      "dcCreator": "Skaberen",
      "dcDate": "Dato",
      "dcDescription": "Beskrivelse",
      "dcDuration": "Varighed",
      "dcFormat": "Format",
      "dcIdentifier": "Identifikator",
      "dcLanguage": "Sprog",
      "dcPublisher": "Udgiver",
      "dcRelation": "Forbindelser",
      "dcRights": "Rettigheder",
      "dcSource": "Kilde",
      "dcSubject": "Emne",
      "dcTitle": "Titel",
      "dcType": "Objekttype",
      "dctermsCreated": "Oprettelsesdato",
      "dctermsExtent": "Omfang",
      "dctermsHasPart": "Består af",
      "dctermsHasVersion": "Har version",
      "dctermsIsFormatOf": "Er format af",
      "dctermsIsPartOf": "Er en del af",
      "dctermsIsReferencedBy": "Er refereret til",
      "dctermsIsReplacedBy": "Er erstattet af",
      "dctermsIsRequiredBy": "Er krævet af",
      "dctermsIssued": "Udstedelsesdato",
      "dctermsMedium": "Medium",
      "dctermsProvenance": "Oprindelse",
      "dctermsReferences": "Referencer",
      "dctermsSpatial": "Steder",
      "dctermsTOC": "Indholdsfortegnelse",
      "dctermsTemporal": "Tidsmæssig",
      "edmCountry": "Leverende land",
      "edmCurrentLocation": "Nuværende placering",
      "edmDataProvider": "Leverende institution",
      "edmHasMet": "Har mødt",
      "edmIncorporates": "Indeholder",
      "edmIntermediateProvider": "Mellemliggende udbyder",
      "edmIsDerivativeOf": "Er afledt af",
      "edmIsRelatedTo": "Er relateret til",
      "edmIsRepresentationOf": "Er repræsentation af",
      "edmIsSimilarTo": "Svarer til",
      "edmIsSuccessorOf": "Er efterfølger til",
      "edmProvider": "Udbyder",
      "edmRealizes": "Indser",
      "edmRights": "Licens for medierne i denne optagelse (medmindre andet er angivet)",
      "edmUgc": "Brugergenereret indhold",
      "europeanaCollectionName": "Navn på samling",
      "keywords": "Nøgleord (leveret af fællesskabet)",
      "timestampCreated": "Tidsstempel oprettet",
      "timestampUpdate": "Tidstempel opdateret",
      "wasPresentAt": "Var til stede på",
      "year": "År"
    },
    "webResource": {
      "about": "RDF Om",
      "dcDescription": "Beskrivelse",
      "ebucoreHasMimeType": "Ebucore MIME-type",
      "edmRights": "Licens til denne medieressource",
      "rdfAbout": "RDF Om"
    }
  },
  "filter": "Filter",
  "filterResults": "Filtrer resultater",
  "footer": {
    "customiseWebsiteLanguage": "Tilpas hjemmesidens sprog",
    "disclaimerLine1": "Europeana er et initiativ fra Den Europæiske Union, der finansieres af EU's Connecting Europe-facilitet og EU's medlemsstater. Europeana-tjenesterne, herunder dette websted, drives af et konsortium ledet af Europeana Foundation i henhold til en servicekontrakt med Europa-Kommissionen.",
    "disclaimerLine2": "Europa-Kommissionen garanterer ikke nøjagtigheden af informationen og påtager sig intet ansvar over for informationen på dette websted. Hverken Europa-Kommissionen eller nogen person, der handler på Europa-Kommissionens vegne, er ansvarlig eller ansvarlig for nøjagtigheden eller brugen af oplysningerne på dette websted.",
    "findUsElsewhere": "Find os et andet sted",
    "imageDescription": "Finansieret af Den Europæiske Union",
    "navigation": {
      "MoreInfoLabel": "Flere oplysninger",
      "about": "Om os",
      "accessibility": "Tilgængelighed",
      "cookies": "Cookies",
      "forDevelopers": "For udviklere",
      "help": "Hjælp",
      "privacy": "Fortrolighedspolitik",
      "provide": "Bliv dataleverandør",
      "subscribe": "Abonner på vores nyhedsbrev",
      "terms": "Vilkår for brug"
    },
    "ourMission": "Vores mission",
    "ourMissionQuote": "Europeana styrker kulturarvsektoren i sin digitale transformation. Vi udvikler ekspertise, værktøjer og politikker til at omfatte digitale forandringer og tilskynde til partnerskaber, der fremmer innovation."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Udforsk vores gallerier",
    "galleries": "Gallerier"
  },
  "goToRecord": "Gå til optagelse",
  "header": {
    "backToMenu": "Luk søgefelt",
    "clearQuery": "Ryd søgning",
    "closeSidebar": "Luk menu",
    "entireCollection": "Søg efter {query} i hele vores samling",
    "europeanaHome": "Europeana startside",
    "inCollection": "Søg efter {query} i {collection}",
    "navigation": {
      "about": "Om os",
      "collections": "Samlinger",
      "europeanaClassroom": "For lærere",
      "help": "Hjælp",
      "home": "Hjem",
      "pro": "For professionelle",
      "stories": "Historier"
    },
    "quickSearch": "Hurtig søgning",
    "searchFor": "Søg efter {query}",
    "searchForEverything": "Søg efter alt",
    "searchForEverythingInCollection": "Søg efter alt i {collection}",
    "searchForEverythingInEntireCollection": "Søg efter alt i hele vores samling",
    "searchForm": "Søg formular",
    "showSidebar": "Vis menu",
    "sideNavigation": "Sidenavigation"
  },
  "homeLinkAlt": "Europeana startside",
  "homePage": {
    "discoverEditorial": "Seneste historier",
    "storiesCTA": "Se alle historier",
    "subHeadline": "Søg, gem og del kunst, bøger, film og musik fra tusindvis af kulturinstitutioner",
    "themesCTA": "Se alle temaer",
    "themesTitle": "Udforsk efter tema",
    "title": "Opdag Europas {digital} kulturarv",
    "titleDigital": "digitale"
  },
  "imageSlider": {
    "handle": "Skydehåndtag"
  },
  "items": {
    "itemCount": "1 artikel |{count} artikler",
    "itemOf": "{max} af {count} artikler",
    "recent": "Seneste varer",
    "recommended": "Anbefalede varer",
    "youMightLike": "Artikler, du måske vil synes om"
  },
  "klaro": {
    "main": {
      "acceptAll": "Accepter alle",
      "acceptSelected": "Accepter valgt",
      "consentModal": {
        "description": "Vi tager dit datas privatliv alvorligt. Her kan du vurdere og tilpasse de tjenester, som vi gerne vil bruge på dette websted. Du har ansvaret! Aktivér eller deaktiver tjenester, som du finder det passende.",
        "title": "Tjenester, vi gerne vil bruge."
      },
      "consentNotice": {
        "description": "Vi holder af dit privatliv og bruger kun data til at forbedre din oplevelse. Vi bruger ingen personlige oplysninger til reklame. Du kan ændre dit samtykke hver 15. dag.",
        "learnMore": "Lad mig vælge"
      },
      "decline": "Jeg afviser",
      "ok": "Okay",
      "purposes": {
        "essential": {
          "description": "Disse tjenester er afgørende for, at dette websted fungerer korrekt. De inkluderer søgeresultatvisning og sprogindstillinger, bevarer den loggede tilstand og holder dit besøg sikkert. Du kan ikke deaktivere dem, da webstedet ellers ikke fungerer korrekt.",
          "title": "Væsentlige tjenester til sikkerhed og tilpasning"
        },
        "usage": {
          "description": "Disse tjenester indsamler oplysningerne for at hjælpe os med bedre at forstå, hvordan hjemmesiden bliver brugt, og hvor smertepunkterne er, hvilket giver os mulighed for at træffe informerede valg for at forbedre din oplevelse.",
          "title": "Tjenester til at registrere brug og feedback på websitet"
        }
      },
      "service": {
        "disableAll": {
          "description": "Brug denne switch til at aktivere eller deaktivere alle valgfrie tjenester.",
          "title": "Aktivere eller deaktivere alle tjenester"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Hjælper med at forbedre vores websted ved lejlighedsvis at anvende eksperimentelle ændringer.",
        "title": "A/B-testning"
      },
      "auth-strategy": {
        "description": "Husker autorisationsstrategien, der skal bruges til at logge ind.",
        "title": "Auth-strategi"
      },
      "debugSettings": {
        "description": "Hjælper med fejlfinding af API -anmodninger",
        "title": "Fejlfinding skifter"
      },
      "hotjar": {
        "description": "Aktiverer en undersøgelses widget, der giver dig mulighed for at svare på vores undersøgelser om tilfredshed med besøgende.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Husker dit foretrukne grænsefladesprog for fremtidig adgang.",
        "title": "Sprogkode"
      },
      "jira-servicedesk": {
        "description": "Aktiverer feedback-widget'en, så du kan kontakte os.",
        "title": "Jira servicedesk"
      },
      "matomo": {
        "description": "Samler anonyme statistikker om, hvordan besøgende interagerer med hjemmesiden.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Viser en meddelelse, når nye funktioner bliver tilgængelige.",
        "title": "Meddelelse om ny funktion"
      },
      "searchResultsView": {
        "description": "Husk, hvis du foretrækker at se søgeresultaterne i en liste- eller gittervisning.",
        "title": "Visning af søgeresultater (liste / gitter)"
      }
    }
  },
  "layout": {
    "skipToMain": "Spring til sideindhold"
  },
  "learnMore": "Få mere at vide om kilden til denne beskrivelse",
  "loading": "Indlæser",
  "loadingResults": "Indlæser resultater",
  "messages": {
    "copyToClipboardSuccess": "Kopieret til udklipsholderen",
    "externalContentError": "Det eksterne indhold kunne ikke indlæses",
    "notFound": "Ikke fundet",
    "paginationLimitExceeded": "Det er kun muligt at få vist de første {limit} søgeresultater."
  },
  "modal": {
    "download": {
      "clickToCopy": "Klik på tilskrivningen for at kopiere den",
      "modalIntro": "Hvis du bruger dette element på nettet eller andre steder, skal du ikke glemme at vise følgende tilskrivning ved siden af det:",
      "modalTitle": "Sig tak"
    }
  },
  "multilingual": {
    "automated": "Automatiseret oversættelse",
    "enrichment": "Berigelse ved partnerprojekter",
    "other": "Andre sprog",
    "stopTranslating": "Stop med at oversætte dette element til {0}.",
    "translateLanguage": "Vil du gerne se dette element i {0} ?",
    "translateQuotaError": "Oversættelsestjeneste er midlertidigt utilgængelig. Prøv igen senere."
  },
  "newFeatureNotification": {
    "dismiss": "Luk",
    "readMore": "Læs mere",
    "text": {
      "searchFilters": "Du kan nu søge efter værdier i de enkelte filtre; tjek det ud!"
    }
  },
  "newWindow": "åbner i nyt vindue",
  "noMoreResults": "Der er ikke flere resultater for din søgning.",
  "noResults": "Ingen resultater",
  "of": "Af",
  "organisation": {
    "city": "By",
    "country": "Land",
    "englishName": "Engelsk navn",
    "nameAcronym": "Navn akronym"
  },
  "pageHasLoaded": "har indlæst",
  "pageNumber": "Side nummer",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Navn"
        },
        "title": "Organisationer"
      },
      "persons": {
        "title": "Personer"
      },
      "places": {
        "title": "Steder"
      },
      "table": {
        "items": "Varer",
        "name": "Navn"
      },
      "times": {
        "title": "Tider"
      },
      "topics": {
        "title": "Emner"
      }
    }
  },
  "pagination": {
    "label": "Paginering"
  },
  "readMore": "Læs mere",
  "recommendation": {
    "prompts": {
      "accept": "Tommelfinger op for at tilføje til galleriet",
      "reject": "Tommelfinger ned, hvis du ikke kan lide det"
    }
  },
  "record": {
    "IIIFViewer": "IIIF-fremviser",
    "actions": {
      "pin": "Fastgør element til tilgængelige enheder"
    },
    "allMetaData": "Alle metadata",
    "copyEmbedLabel": "Integrer kode (Klik for at kopiere)",
    "exploreMore": "Udforsk mere",
    "extendedInformation": "Udvidede oplysninger",
    "goodToKnow": "Værd at vide",
    "hideAll": "Skjul alle oplysninger",
    "location": "Placering",
    "locationOnMap": "Placering på kort",
    "mediaPlayer": "Medie afspiller",
    "record": "Registrering",
    "showAll": "Vis alle oplysninger",
    "similarItems": "Lignende artikler",
    "status": {
      "unpublished": "[Ikke-publiceret element]"
    },
    "transcription": "Transskription",
    "transcriptionDisclaimer": "Dette indhold er leveret af offentligheden, ikke af den institution, der leverede denne artikel."
  },
  "related": {
    "editorial": {
      "title": "Historier, du måske kan lide"
    }
  },
  "relatedCollections": "Relaterede samlinger",
  "removeFilter": "Fjern {filterLabel} filter",
  "reset": "Nulstil",
  "resourceWikimedia": "Ressource fra Wikimedia Commons",
  "results": "Resultater",
  "resultsFor": "Resultater for {0}",
  "resultsLimitWarning": "Yderligere resultater vises ikke, da kun de første 1000 mest relevante resultater vises. Hvis du ikke har fundet det, du leder efter, kan du overveje at præcisere søgningen.",
  "resultsWithin": "Resultater inden for {0} {1} for {2}",
  "search": {
    "boost": {
      "placeholder": "Indtast feltforøgende forespørgsel"
    },
    "title": "Søg"
  },
  "searchHasLoaded": "{0} resultater returneret",
  "searchPlaceholder": "Søg i mere end 50 millioner genstande",
  "searchResults": "Søg",
  "searchResultsFor": "{0} - Søg",
  "searchSuggestions": "Søgeforslag",
  "searchTier": {
    "button": {
      "hide": "Skjul disse emner",
      "show": "Vis disse emner"
    },
    "text": {
      "hide": "Emner, der ikke opfylder vores udgivelseskriterier, vises.",
      "show": "Flere emner matcher din søgning, men opfylder ikke vores udgivelseskriterier."
    }
  },
  "searchViews": {
    "grid": "Gittervisning",
    "list": "Listevisning",
    "mosaic": "Mosaik udsigt"
  },
  "set": {
    "actions": {
      "addTo": "Føj til galleri",
      "create": "Opret galleri",
      "createNew": "Opret nyt galleri",
      "delete": "Slet galleri",
      "edit": "Rediger galleri",
      "update": "Opdater galleri"
    },
    "form": {
      "description": "Beskrivelse af galleri",
      "private": "Hold dette galleri privat",
      "required": "påkrævet  felt",
      "title": "Navn på galleri"
    },
    "labels": {
      "curatedBy": "Kurateret af",
      "private": "Privat galleri"
    },
    "notifications": {
      "deleted": "Dit galleri er blevet slettet.",
      "likeLimit": {
        "body": "Vi beklager, men du er i øjeblikket begrænset til at kunne synes om maksimalt 100 artikler. Vi fjerner denne begrænsning snart!",
        "title": "100 synes om'er"
      },
      "updated": "Elementet blev føjet til galleriet."
    },
    "prompts": {
      "delete": "Er du sikker på, at du vil slette dette galleri? Hvis du sletter dette galleri, mister du alle de artikler, du har tilføjet i det."
    }
  },
  "showLess": "Vis mindre",
  "showMore": "Vis mere",
  "sideFilters": {
    "noOptions": "Der er ingen tilgængelige muligheder at vælge",
    "search": "Søg"
  },
  "statuses": {
    "liked": "Kunne lide",
    "pinned": "Fastgjort"
  },
  "storiesPage": {
    "title": "Historier"
  },
  "website": "Websted",
  "youMightAlsoLike": "Du vil måske også kunne lide"
};
